import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import Field from 'components/Form/Field';
import Textarea from 'components/Form/Textarea';
import DateRange from 'components/Form/DateRange';
import { LegalAssociationsActivitiesOverthrowItemModel } from 'forms/sections/legal/associations/activitiesOverthrow/types';
import { CommonOnError, CommonOnUpdate, CommonScrollIntoView } from 'types/props';
import { ValidationElementProps } from 'components/Form/ValidationElement/ValidationElement';
import { AccordionItemProps } from 'components/Form/Accordion/types';
import { ErrorCode } from '@redux/modules/application/reducers/error';

interface Props
  extends Partial<LegalAssociationsActivitiesOverthrowItemModel>,
    ValidationElementProps,
    AccordionItemProps {
  required?: boolean
  onUpdate?: CommonOnUpdate
  attribute?: string
  scrollIntoView?: CommonScrollIntoView
  onError?: CommonOnError
}

export default class ActivitiesToOverthrowItem extends ValidationElement<Props> {
  update = (queue: Partial<LegalAssociationsActivitiesOverthrowItemModel>) => this.props.onUpdate({
    Reasons: this.props.Reasons,
    Dates: this.props.Dates,
    ...queue,
  });

  updateReasons = (values: LegalAssociationsActivitiesOverthrowItemModel['Reasons']) => this.update({
    Reasons: values,
  });

  updateDates = (values: LegalAssociationsActivitiesOverthrowItemModel['Dates']) => this.update({
    Dates: values,
  });

  render() {
    const attribute = `${this.props.attribute}.items[${this.props.$index}].Item`;

    return (
      <div>
        <Field
          attribute={`${attribute}.Reasons`}
          title={i18n.t('legal.associations.activities.heading.reasons')}
          adjustFor="textarea"
          scrollIntoView={this.props.scrollIntoView}
        >
          <Textarea
            attribute={`${attribute}.Reasons`}
            name="Reasons"
            {...this.props.Reasons}
            onUpdate={this.updateReasons}
            onError={this.props.onError}
            className="legal-associations-activities-reasons"
            required={this.props.required}
          />
        </Field>

        <Field
          attribute={`${attribute}.Dates`}
          title={i18n.t('legal.associations.activities.heading.dates')}
          help="legal.associations.activities.help.dates"
          adjustFor="daterange"
          scrollIntoView={this.props.scrollIntoView}
        >
          <DateRange
            attribute={`${attribute}.Dates`}
            name="Dates"
            {...this.props.Dates}
            minDateEqualTo
            onUpdate={this.updateDates}
            onError={this.props.onError}
            className="legal-associations-activities-dates"
            required={this.props.required}
            hideFromDay
            hideToDay
          />
        </Field>
      </div>
    );
  }
}

ActivitiesToOverthrowItem.defaultProps = {
  onUpdate: (queue) => {},
  onError: (value, arr: ErrorCode[]) => arr,
};
